import { IconProp } from "@fortawesome/fontawesome-svg-core"
import {
  faCopy,
  faEdit,
  faEraser,
  faLocationArrow,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { Fragment } from "react"
import {
  Nav,
  NavDropdown,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap"
import { TrimName } from "modules/PortPredictor/components/PortPredictorItinerary/Utilities"
import { PrevetState } from "../hooks/prevetStateReducer"
import { useWoopraAPI } from "instrumentation/tracking/useWoopraApi"

export const CreateItineraryMenuList = (
  tabStates: PrevetState[] | undefined,
  deleteHandler: (id: number, name: string) => void
): JSX.Element[] | undefined => {
  return tabStates?.map((item, index) => (
    <NavDropdown.Item
      key={index}
      onClick={(event: { preventDefault: () => void }) => {
        event.preventDefault()
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div style={{ marginRight: "15px" }}>{item.tabName}</div>
        </div>
        <div
          style={{
            position: "relative",
          }}
        >
          <FontAwesomeIcon
            icon={faTrash}
            className="fa-thin"
            style={{
              color: "rgb(255,0,0,.60)",
            }}
          />
          <div
            onClick={(event) => {
              event.preventDefault()
              event.stopPropagation()
              deleteHandler(index, item.tabName)
            }}
            title="Delete"
            style={{
              position: "absolute",
              top: "-10px",
              left: "-10px",
              right: "-10px",
              bottom: "-10px",
              border: "1px solid red",
              borderRadius: "5px",
              boxShadow: "0 0 5px rgba(255, 0, 0, 0.1)", // Emboss effect
              opacity: 0, // Initially hidden
              transition: "opacity 0.3s", // Smooth transition
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "1" // Show on mouse enter
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "0" // Hide on mouse leave
            }}
          ></div>
        </div>
      </div>
    </NavDropdown.Item>
  ))
}

export const ConstructTabMenuItem = (
  iconName: IconProp,
  label: string,
  disable: boolean,
  color: string | undefined
): JSX.Element => {
  const rgbOpacity = disable ? "0.45" : "1"
  const itemColor = `rgb(91, 98, 107, ${rgbOpacity})`
  return (
    <>
      <FontAwesomeIcon
        icon={iconName}
        className="fa-thin"
        style={{
          color: color && !disable ? color : itemColor,
        }}
      />
      <span
        style={{
          color: itemColor,
        }}
      >
        &nbsp;&nbsp;&nbsp;{label}
      </span>
    </>
  )
}

const ConstructTabLabel = (
  state: PrevetState,
  closeTabHandler: ((id: number) => void) | undefined
): JSX.Element => {
  const isLoadingTab = state.id === -1

  const tabName = state.tabName
  const isNewTab = state.tabName.startsWith("Tab")

  return (
    <OverlayTrigger
      placement="top"
      delay={{ show: 1000, hide: 400 }}
      overlay={
        <Tooltip id="tooltip-top">
          <>
            <div>{tabName}</div>
          </>
        </Tooltip>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <div
          ref={ref}
          {...triggerHandler}
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {isLoadingTab && (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              &nbsp;&nbsp;
            </>
          )}
          {TrimName(tabName)}&nbsp;&nbsp;
          {!isNewTab && !isNaN(parseFloat(state.perfExposureValue)) && (
            <div style={{ display: "flex" }}>
              {" "}
              (
              <div
                style={{
                  color:
                    parseFloat(state.perfExposureValue) > 0
                      ? "#e61f2f"
                      : "#00763b",
                }}
              >
                {Math.abs(parseInt(state.perfExposureValue, 10)).toLocaleString(
                  "en-US"
                )}
              </div>
              &nbsp;&nbsp;
              <FontAwesomeIcon
                icon={faLocationArrow}
                className="fa-thin fa-rotate-by"
                style={
                  {
                    height: "12px",
                    marginTop:
                      parseFloat(state.perfExposureValue) > 0 ? "2px" : "6px",
                    color:
                      parseFloat(state.perfExposureValue) > 0
                        ? "#e61f2f"
                        : "#00763b",
                    "--fa-rotate-angle":
                      parseFloat(state.perfExposureValue) > 0
                        ? "135deg"
                        : "-45deg",
                  } as React.CSSProperties
                }
              />
              )
            </div>
          )}
          &nbsp;&nbsp;
          {!isLoadingTab && (
            <>
              {closeTabHandler && (
                <>
                  <div>&nbsp;&nbsp;&nbsp;</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} size="xs" style={{}} />
                    <div
                      onClick={(event) => {
                        event.preventDefault()
                        event.stopPropagation()
                        closeTabHandler(state.id)
                      }}
                      title="Close"
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "-10px",
                        right: "-10px",
                        bottom: "-10px",
                        border: "1px solid lightgray",
                        borderRadius: "3px",
                        boxShadow: "0 0 5px rgba(211, 211, 211, 0.1)", // Emboss effect
                        opacity: 0, // Initially hidden
                        transition: "opacity 0.3s", // Smooth transition
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.opacity = "1" // Show on mouse enter
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.opacity = "0" // Hide on mouse leave
                      }}
                    ></div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}
    </OverlayTrigger>
  )
}

export const ConstructPrevetTab = (
  prevetStates: PrevetState[],
  selectedId: number,
  renameHandler: () => void,
  duplicateHandler: () => void,
  closeTabHandler: (id: number) => void,
  clearTabHandler: (id: number) => void
): JSX.Element[] => {
  const { postTrackingEvent } = useWoopraAPI()
  let visibleTab: any[] = []
  const availableTabs = prevetStates && prevetStates.filter((i) => !i.deleted)
  const hasMoreThanOneOpened = availableTabs ? availableTabs?.length > 1 : false
  availableTabs.forEach((state: PrevetState) => {
    // const hasNoUuid = !itinerary.uuid || itinerary.uuid === ""
    if (state.id === selectedId) {
      visibleTab.push(
        <NavDropdown
          active
          title={ConstructTabLabel(
            state,
            hasMoreThanOneOpened ? closeTabHandler : undefined
          )}
          id="nav-dropdown"
          key={state.id}
          style={{ margin: 0 }}
        >
          <NavDropdown.Item
            eventKey="rename"
            title="Rename"
            key="rename"
            onClick={() => {
              renameHandler()
              postTrackingEvent({
                page: "/prevetting",
                event: "tab_rename",
                properties: {
                  component: "prevet_tab",
                },
              })
            }}
          >
            {ConstructTabMenuItem(faEdit, "Rename", false, undefined)}
          </NavDropdown.Item>
          <NavDropdown.Item
            eventKey="duplicate"
            title="Duplicate"
            key="duplicate"
            onClick={() => {
              duplicateHandler()
              postTrackingEvent({
                page: "/prevetting",
                event: "tab_duplicate",
                properties: {
                  component: "prevet_tab",
                },
              })
            }}
          >
            {ConstructTabMenuItem(faCopy, "Duplicate", false, undefined)}
          </NavDropdown.Item>
          {
            <Fragment key="close">
              <NavDropdown.Divider />
              <NavDropdown.Item
                eventKey="close"
                title={!hasMoreThanOneOpened ? "Clear" : "Close"}
                key="close"
                onClick={() => {
                  postTrackingEvent({
                    page: "/prevetting",
                    event: "tab_clear",
                    properties: {
                      component: "prevet_tab",
                    },
                  })
                  if (!hasMoreThanOneOpened) {
                    return clearTabHandler(state.id)
                  }
                  return closeTabHandler(state.id)
                }}
              >
                {ConstructTabMenuItem(
                  !hasMoreThanOneOpened ? faEraser : faXmark,
                  !hasMoreThanOneOpened ? "Clear" : "Close",
                  false,
                  undefined
                )}
              </NavDropdown.Item>
            </Fragment>
          }
        </NavDropdown>
      )
    } else {
      visibleTab.push(
        <Nav.Item key={state.id}>
          <Nav.Link title={state.tabName} eventKey={state.id}>
            {ConstructTabLabel(
              state,
              hasMoreThanOneOpened ? closeTabHandler : undefined
            )}
          </Nav.Link>
        </Nav.Item>
      )
    }
  })
  return visibleTab
}
